import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const fetchDraftTakeawayOrders = ({ owner, pos_profile } = {}) => {
    const filters = [["Draft Table Order", "status", "=", "Draft"]];
    if (owner) {
        filters.push(["Draft Table Order", "owner", "=", owner]);
    }
    if (pos_profile) {
        filters.push(["Draft Table Order", "pos_profile", "=", pos_profile]);
    }

    const params = {
        doctype: "Draft Table Order",
        fields: JSON.stringify([
            "name",
            "customer",
            "address",
            "status",
            "table",
            "designated_number",
            "creation",
            "modified",
            "amount",
            "owner",
            "pos_profile",
        ]),
        filters: JSON.stringify(filters),
        order_by: "modified desc",
        limit_start: 0,
        limit_page_length: 100,
    };

    return axios.get("method/frappe.client.get_list", { params });
};

export const useDraftTakeawayOrders = ({ owner, pos_profile } = {}) => {
    return useQuery(
        ["draftTakeawayOrders", owner || "", pos_profile || ""],
        async () => {
            const { data } = await fetchDraftTakeawayOrders({ owner, pos_profile });
            return data.message || [];
        }
    );
};
